import { makeStyles } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import GraphIcon from '@material-ui/icons/AccountTree';
import { LinkButton } from '@backstage/core-components';
import {
  createFrontendModule,
  PluginHeaderActionBlueprint,
} from '@backstage/frontend-plugin-api';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import { useCatalogRootPath } from '../shared/useCatalogRootPath';
import { useByxT } from '../shared/translations';
import { catalogGraphMessages } from './translations';

const useStyles = makeStyles(theme => ({
  // Design system text button: 32 px, 13 px label in primary, an 18 px
  // arrow-back icon before it.
  back: {
    height: 32,
    padding: theme.spacing(0, 1),
    fontSize: 13,
    textTransform: 'none',
    '& .MuiButton-startIcon svg': { fontSize: 18 },
  },
}));

/** "Voltar à lista" in the Grafo header bar: back to the Catálogo. */
export function BackToListButton() {
  const classes = useStyles();
  const { t } = useByxT();
  return (
    <LinkButton
      to={useCatalogRootPath()}
      variant="text"
      color="primary"
      startIcon={<ArrowBackIcon />}
      className={classes.back}
    >
      {t('catalogGraph.backToList')}
    </LinkButton>
  );
}

export const byxBackToListAction = PluginHeaderActionBlueprint.make({
  name: 'byx-back-to-list',
  params: {
    loader: () => Promise.resolve(<BackToListButton />),
  },
});

/**
 * Grafo do catálogo in the v2 design (Stories 5.5, 2.3; AC-20): only the
 * page loader is replaced, with the app page composed on the exported
 * `EntityRelationsGraph`, and the graph icon set. The route stays
 * `/catalog-graph`, out of the menu (AD-12); the title "Grafo" is set in
 * app-config.yaml. "Voltar à lista" is the plugin's header action, so it
 * shows on this page only.
 */
export const byxCatalogGraphPlugin = catalogGraphPlugin.withOverrides({
  extensions: [
    catalogGraphPlugin.getExtension('page:catalog-graph').override({
      factory: originalFactory =>
        originalFactory({
          params: {
            icon: <GraphIcon />,
            loader: async () => {
              const { ByxCatalogGraphPage } = await import(
                './ByxCatalogGraphPage'
              );
              return <ByxCatalogGraphPage />;
            },
          },
        }),
    }),
    byxBackToListAction,
  ],
});

/**
 * pt-BR texts of the stock catalog graph (Story 2.3, AC-21). The app's
 * translations input only accepts extensions of the app plugin itself.
 */
export const catalogGraphTranslationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [catalogGraphMessages],
});
